export default __webpack_public_path__ + "static/media/more.968f7960.svg";